import React from "react";
import { prettifyLargeCount } from "@sscs/utils";
import styles from "./severityCountChiclet.module.scss";
const SeverityCountChiclet = ({ severity, count, fractionDigits, }) => {
    return (React.createElement("div", { className: `${styles.root} ${styles[`root-${severity}`]}` },
        React.createElement("span", { className: `${styles["chiclet-severity"]} ${styles[`chiclet-severity-${severity}`]}` }, severity.toUpperCase().slice(0, 1)),
        React.createElement("span", { className: styles["chiclet-title"] }, prettifyLargeCount(count, fractionDigits))));
};
export default SeverityCountChiclet;
//# sourceMappingURL=SeverityCountChiclet.js.map